import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Loading overlay component for showing loading states
 * Can be used as a full-screen or container-scoped overlay
 */
const LoadingOverlay = ({ 
  loading, 
  message = 'Loading...', 
  children, 
  fullScreen = false,
  opacity = 0.7,
  blur = false
}) => {
  if (!loading) {
    return children || null;
  }

  return (
    <Box sx={{ position: 'relative' }}>
      {children}
      
      <Box 
        sx={{ 
          position: fullScreen ? 'fixed' : 'absolute', 
          top: 0, 
          left: 0, 
          right: 0, 
          bottom: 0, 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center', 
          justifyContent: 'center',
          backgroundColor: `rgba(255, 255, 255, ${opacity})`,
          backdropFilter: blur ? 'blur(3px)' : 'none',
          zIndex: 1000
        }}
      >
        <CircularProgress size={40} sx={{ mb: 2 }} />
        {message && (
          <Typography variant="body1" color="text.secondary">
            {message}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default LoadingOverlay;
